import { createPortal } from "react-dom";

const StaffListPopup = ({ staffs, onClose }) => {
  return createPortal(
    <div
      className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="bg-white w-[420px] rounded-xl shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="border-b px-5 py-3 flex justify-between items-center">
          <h3 className="font-semibold text-gray-800">
            Danh sách nhân viên ({staffs.length})
          </h3>
          <button onClick={onClose}>✕</button>
        </div>

        <div className="max-h-[360px] overflow-auto p-4 space-y-2">
          {staffs.map((s, i) => (
            <div
              key={s.id}
              className="flex items-center justify-between px-3 py-2 bg-gray-50 rounded-lg"
            >
              <span className="text-sm font-medium text-gray-700">
                {i + 1}. {s.fullName}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default StaffListPopup;
